import { render, staticRenderFns } from "./SingleProperty.vue?vue&type=template&id=69bce134&scoped=true"
import script from "./SingleProperty.vue?vue&type=script&lang=js"
export * from "./SingleProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bce134",
  null
  
)

export default component.exports